
import Cookies from 'js-cookie'

export const Currency ='₦';
export const PKLIVE  ='pk_live_a9d35f401f2f58b6d9d7f7678f5bde0935b81ecc';//'pk_test_688ead34020cedd7f2dfd5543c90d4a831d33d40';
export const PK_SECRET ='sk_live_d66fa42a76925be833355add6f05d8f1a54ad989'
export const FLPKEY = 'FLWPUBK-8b9a286d6960a0eefe8379de801a0eda-X';//'FLWPUBK_TEST-ba1f52064fac16ac5f429566759815b2-X';

export const API_IMAGES = 'https://dashboard.nsukedc.com/public/images'; //"http://localhost:8000/images";
export const CLOUD_IMAGES = '';
export const API_URL =   'https://dashboard.nsukedc.com/api';


export const UserCode = Cookies.get('app_spcd')?Cookies.get('app_spcd'):undefined
export const Token = Cookies.get('app_tcscdk')?Cookies.get('app_tcscdk'):undefined

export const Contact = {
    email:'edcatnsuk@gmail.com',
    telephone:'+234 813 530 2960',
    whatsapp:'08135302960',
    website:'https://nsukedc.com',
    address: 'EDC, NSUK'
}
export const FormatNumber = (num:number)=>{
    let newNumber = Number(num)
    return  newNumber.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export const config = {
    headers: { 'content-type': 'multipart/form-data',
    'Authorization': `Bearer ${Token}`}
} 